import { render, staticRenderFns } from "./SalesSubOrderDetail.vue?vue&type=template&id=bef1dc02&scoped=true&"
import script from "./SalesSubOrderDetail.vue?vue&type=script&lang=js&"
export * from "./SalesSubOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./SalesSubOrderDetail.vue?vue&type=style&index=0&id=bef1dc02&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef1dc02",
  null
  
)

export default component.exports